import React from "react";
import { Loader2 } from "lucide-react";
import { useTranslation } from "@/context/LanguageContext";

export const RoomReconnectingBanner: React.FC<{ visible: boolean }> = ({
  visible,
}) => {
  const { t } = useTranslation();
  if (!visible) return null;
  return (
    <div className="flex items-center justify-center gap-2 border-b border-border/40 bg-muted/60 px-3 py-1 text-xs text-muted-foreground">
      <Loader2 className="h-3 w-3 animate-spin" />
      <span>{t("room.reconnecting") || "Reconnecting…"}</span>
    </div>
  );
};
